__turbopack_context__.v({
  "ProseMirror": "index-module-scss-module__zz2ejW__ProseMirror",
  "ProseMirror-gapcursor": "index-module-scss-module__zz2ejW__ProseMirror-gapcursor",
  "dark": "index-module-scss-module__zz2ejW__dark",
  "has-focus": "index-module-scss-module__zz2ejW__has-focus",
  "is-active": "index-module-scss-module__zz2ejW__is-active",
  "is-empty": "index-module-scss-module__zz2ejW__is-empty",
  "node-aiImage": "index-module-scss-module__zz2ejW__node-aiImage",
  "node-aiWriter": "index-module-scss-module__zz2ejW__node-aiWriter",
  "node-imageBlock": "index-module-scss-module__zz2ejW__node-imageBlock",
  "node-imageUpload": "index-module-scss-module__zz2ejW__node-imageUpload",
  "node-sectionNode": "index-module-scss-module__zz2ejW__node-sectionNode",
  "node-tableOfContentsNode": "index-module-scss-module__zz2ejW__node-tableOfContentsNode",
  "plainEmphasis": "index-module-scss-module__zz2ejW__plainEmphasis",
  "plainListMarkers": "index-module-scss-module__zz2ejW__plainListMarkers",
  "shimmer": "index-module-scss-module__zz2ejW__shimmer",
  "shimmer-text-animation": "index-module-scss-module__zz2ejW__shimmer-text-animation",
});
